import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const SERIES_COLORS = ["var(--c-s1)", "var(--c-success)", "var(--c-warning)", "var(--c-danger)", "var(--c-s1)"];

const SERIES_LABELS = {
  revenue: "Выручка",
  gross_profit: "Прибыль",
  count: "Кол-во",
};

/** Renders a `chartSpec` produced by the assistant's tool executors (see
 * `assistant/tools.py::to_chart_spec`) — a small fixed mapping, not a generic renderer,
 * matching the recharts conventions already used on `AccountingWholesaleSalesPage.js`. */
export default function AssistantChart({ spec }) {
  if (!spec || !Array.isArray(spec.data) || spec.data.length === 0) return null;

  const ChartComponent = spec.chartType === "line" ? LineChart : BarChart;
  const SeriesComponent = spec.chartType === "line" ? Line : Bar;

  return (
    <div style={styles.card}>
      <ResponsiveContainer width="100%" height={220}>
        <ChartComponent data={spec.data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--c-border)" />
          <XAxis dataKey={spec.xKey} stroke="var(--c-text-dim)" tick={{ fontSize: 13 }} />
          <YAxis stroke="var(--c-text-dim)" tick={{ fontSize: 13 }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 13 }} />
          {(spec.series || []).map((key, idx) => (
            <SeriesComponent
              key={key}
              dataKey={key}
              name={SERIES_LABELS[key] || key}
              fill={SERIES_COLORS[idx % SERIES_COLORS.length]}
              stroke={SERIES_COLORS[idx % SERIES_COLORS.length]}
            />
          ))}
        </ChartComponent>
      </ResponsiveContainer>
    </div>
  );
}

/** Debt list is naturally tabular (see `pos/services/wholesale_debt.py`) — no chart mapper
 * is registered for it server-side, so it's rendered here as a plain table instead. */
export function AssistantDebtTable({ customers }) {
  if (!Array.isArray(customers) || customers.length === 0) return null;
  return (
    <div style={styles.card}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Клиент</th>
            <th style={styles.th}>Телефон</th>
            <th style={styles.th}>Долг</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((c) => (
            <tr key={c.id}>
              <td style={styles.td}>{c.name}</td>
              <td style={styles.td}>{c.phone || "—"}</td>
              <td style={styles.td}>{Number(c.total_debt).toLocaleString("ru-RU", { minimumFractionDigits: 2 })}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  card: {
    background: "var(--c-input)",
    border: "1px solid var(--c-border)",
    borderRadius: 16,
    padding: 8,
    marginTop: 8,
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 14 },
  th: { textAlign: "left", padding: "4px 6px", color: "var(--c-text-sub)", borderBottom: "1px solid var(--c-border)" },
  td: { padding: "4px 6px", borderBottom: "1px solid var(--c-border)", color: "var(--c-text)" },
};
